<template>
  <div>
    <div v-if="payload.login.value != undefined && payload.logout == undefined">
      <p>לא נרשמה יציאה</p>
      <a @click="openModal" class="button is-info">עדכן שעת יציאה</a>
    </div>
    <div v-if="payload.logout == ''" class="relative is-flex is-align-items-center">
      <div class="loading"></div>
    </div>
    <div v-if="payload.logout != undefined && payload.logout.value != undefined">
      <p>{{ payload.logout.display_text }}</p>
    </div>
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper'
import { mapMutations } from 'vuex'
export default {
  name: 'presence-report-logout-content',
  props: ['payload'],
  data () {
    return {
      time_helper: new TimeHelper()
    }
  },
  methods: {
    openModal () {
      this.create({
        designator: 'presence-report-logout-confirmation',
        component_name: 'PresenceReportLogoutConfirmation',
        login_date: this.payload.login.value,
        recruiter: this.payload.recruiter,
        modal_title: 'Logout Confirmation'
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
